import { render, staticRenderFns } from "./CustomRadioIcon.vue?vue&type=template&id=740c9b46&"
import script from "./CustomRadioIcon.vue?vue&type=script&lang=js&"
export * from "./CustomRadioIcon.vue?vue&type=script&lang=js&"
import style0 from "./CustomRadioIcon.vue?vue&type=style&index=0&id=740c9b46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports